import _debounce from 'lodash.debounce';

/**
 * Adds top padding to <body> element to make up for header nav's "fixed" positioning
 */
const HeaderNavContentPush = {
  init() {
    const self = this;

    this.addPaddingToMainContent();

    // Event :: window resize
    window.onresize = _debounce(() => {
      self.addPaddingToMainContent();
    }, 200);
  },

  addPaddingToMainContent() {
    let bannerHeight = document.querySelector('.js-site-header').offsetHeight;

    // WP admin bar adjustment (if present)
    // if ( document.querySelector('body').classList.contains('admin-bar') ) {
    //   bannerHeight += document.getElementById('wpadminbar').offsetHeight;
    // }

    document.querySelector('body').style.paddingTop = bannerHeight + "px";
  }
};

export default HeaderNavContentPush;
